// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "ec8a6d14245d43a9f8ca5d44aae3af549b6f2989/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};